import axios from "axios"
import { IsEmptyString } from "../../Components/GeneralFunctions.jsx"

const isBeta = false //window.location.href.includes("webclient2.0.cloudcti.nl/webclientjeroen") || window.location.href.includes("localhost:3000/webclientjeroen") || window.location.href.includes("webclient2.0.cloudcti.nl/webclientbonlinebeta");
const clientIdRelease = "00c79caa-7bc2-4956-a530-c4e9ffd97869";
const clientIdBeta = "a6cc1627-06fe-4f8c-b970-79ad784718f4";
const clientIdRc = "990b1df7-58f5-4716-8a21-6037b368f6a8";
const clientId = window.location.href.includes("webclient2.0.cloudcti.nl/webclientrc") ? clientIdRc : (isBeta ? clientIdBeta : clientIdRelease);
const proxyUrl = "https://hubspotservices.cloudcti.nl/proxy" + (isBeta ? "beta" : "");

// All communication with the HubSpot Proxy server must include the origin header with the full url for logging
axios.interceptors.request.use(
  config => {
        if (config.url.includes("hubspotservices") && config.url.includes("proxy")) {
            config.headers["hbsenderurl"] = window.location.href;
        }
        return config;
    },
    error => {
        console.log('Error in request interceptor: ', error);
        return Promise.reject(error);
    }
);

async function ChangeAssociationsHsObject(engagementId, newObject)
{
    console.log("ChangeAssociationsHsObject",engagementId,newObject);
    
    try
    {
        const config = { headers: { Authorization: `Bearer ${localStorage.getItem("securitytoken")}` } };
        await axios.delete(`${proxyUrl}/clearAssociations?portalId=${localStorage.hb_portalId}&callId=${engagementId}`, config)
        console.log("Associations for " + engagementId + " succesfully cleared");
    }
    catch(error)
    {
        console.log("Associations for " + engagementId + " not cleared", error);
    }     
    AssociateHsObject(newObject,engagementId)
}

function DisassociateHsObject(hsObject, engagementId) {
    console.log("DisassociateHsObject",hsObject,engagementId);
    if ((hsObject !== undefined) && (hsObject?.objectCoordinates?.objectId != null))
    {
        const config = { headers: { Authorization: `Bearer ${localStorage.getItem("securitytoken")}` } };
        axios.delete(`${proxyUrl}/removeAssociation?portalId=${localStorage.hb_portalId}&callId=${engagementId}&toObjectTypeId=${hsObject.objectCoordinates.objectTypeId}&toObjectId=${hsObject.objectCoordinates.objectId}`, config)
        .then(response => {
            console.log("Previous association succesfully removed");
        }).catch((error) => {
            console.log(error);
        });
    }
}

// Hubspot sometimes automatically associates with the an object, so we need to disassociate it first
// The logic behind the association is unclear, so we clear all associations when first receiving a call
function ClearAssociationsHsObject(engagementId) {
        const config = { headers: { Authorization: `Bearer ${localStorage.getItem("securitytoken")}` } };
    axios.delete(`${proxyUrl}/clearAssociations?portalId=${localStorage.hb_portalId}&callId=${engagementId}`, config)
    .then(response => {
        console.log("Alls of object's associations succesfully removed");
    }).catch((error) => {
        console.log(error);
    });
}

function AssociateHsObject(hsObject, engagementId) {
    
    console.log("AssociateHsObject1",hsObject, engagementId)

    //2026-04-17: associate with a company if linked
    const AssociateToObjectType = IsEmptyString(hsObject.associatedcompanyid) ?  hsObject.objectCoordinates.objectTypeId : "0-2" //companytypeid
    const AssociateToObjectId = IsEmptyString(hsObject.associatedcompanyid) ?  hsObject.objectCoordinates.objectId : hsObject.associatedcompanyid    
    
    const bodyAss = {
        portalId: localStorage.hb_portalId,
        callId: engagementId,
        toObjectTypeId: AssociateToObjectType,
        toObjectId: AssociateToObjectId
    }

    const config = { headers: { Authorization: `Bearer ${localStorage.getItem("securitytoken")}` } };
    axios.post(proxyUrl + "/addAssociation", bodyAss, config)
    .then(response => {
        // Adjust the call history in local storage to include the new association ID
        var callHistoryHb = JSON.parse(localStorage.getItem("hb_callhistory") ?? "[]");
        
        // AssociateHsObject might be called after a new call already started, or engagementId might be null
        var callIndex = 0;
        if (callHistoryHb[0].EngagementId == null) {
            if (callHistoryHb[1].EngagementId == engagementId) 
                callIndex = 1;
            else {
                callIndex = 0;
                console.log("Missing EngagementId in call history, is the last call history entry now wrong?");
            }
        }
        else if (callHistoryHb[0].EngagementId != engagementId)
            callIndex = 1;

        var call = callHistoryHb[callIndex];
        call.EngagementId = engagementId; // Either overrides a null value or is identical to the existing one

        // Update the name with recognition
        if (hsObject.callerIdType == "CONTACT") {
            const firstName = hsObject.firstName ? hsObject.firstName + " " : "";
            const lastName = hsObject.lastName ?? "";
            call.Name = firstName + lastName;
        }
        else if (hsObject.callerIdType == "COMPANY")
            call.Name = hsObject.name;

        callHistoryHb[callIndex] = call;
        localStorage.setItem("hb_callhistory", JSON.stringify(callHistoryHb));
        setTimeout(() => {
            new BroadcastChannel("cloudctiwebclient2024").postMessage("calllistchanged");
        }, 1000)
        
        localStorage.hb_lastAssociatedObjectId = AssociateToObjectId;
        localStorage.hb_lastAssociatedCallId = engagementId;
        console.log("Association succesfully added");
    }).catch((error) => {
        console.log(error);
    });
}

async function RecognitionByNumber(externalNumber) {
    const bodyNotes = {
        portalId: localStorage.hb_portalId,
        phoneNumber: externalNumber
    }
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem("securitytoken")}` } };
    var recognitionObj;
    const foo = await axios.post(proxyUrl + "/recognition", bodyNotes, config)
    .then(response => {
        recognitionObj = response.data;
    }).catch((error) => {
        console.warn("Error for recognition request for " + externalNumber + ", returning empty.", error);
        recognitionObj = { results: [], oldestObject: null };
    });
    return recognitionObj;
}

export { isBeta, proxyUrl, clientId, AssociateHsObject, DisassociateHsObject, ClearAssociationsHsObject, ChangeAssociationsHsObject, RecognitionByNumber };